var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-catalog"}},[((_vm.isEditDrawerShow && _vm.isShowWindow === 2) || _vm.currentEditHeader !== 'catalog')?_c('div',{staticClass:"edit-wrapper fd-js-excludes",class:[
      _vm.MobileClass,
      _vm.catalogClass,
      _vm.BigScreenClass,
      _vm.catelogOrSearchKey,
      {
        AsideAnimate: (!_vm.isMobile && !_vm.$route.meta.requiresAuth) || !_vm.isShowCommerHeader,
        AsideEditor: !_vm.isMobile && _vm.isShowCommerHeader && _vm.$route.meta.requiresAuth && this.currentEditHeader !== 'catalog'
      }
    ],attrs:{"id":"edit-wrapper"},on:{"click":_vm.handleShowML}},[_c('div',{staticClass:"catalog-box fd-js-excludes"},[_c(_vm.currentEditHeaderTitle || _vm.currentEditHeader,{tag:"component"})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }